// src/components/About.jsx
import { ABOUT_CARDS, ABOUT_PILLS } from '../data/content';
import './About.css';

export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-text fade-in">
            <p className="section-label">About Us</p>
            <h2 style={{ marginBottom: '28px' }}>Engineering intelligence into industrial operations.</h2>
            <p>
              AI GAV INDIA PVT LTD is an industrial technology company based in Noida, India.
              We build AI-driven and IoT-enabled solutions that help manufacturers, energy
              companies, and process industries operate more intelligently.
            </p>
            <p>
              Our team combines deep industrial domain expertise with cutting-edge machine
              learning and systems engineering — delivering solutions that work in the real
              world, not just in demos.
            </p>
            <p>
              We believe the next era of industrial performance won't come from buying
              expensive off-the-shelf platforms. It will come from focused, context-aware
              AI built specifically for your processes.
            </p>
            <div className="about-pills">
              {ABOUT_PILLS.map((pill) => (
                <span key={pill} className="about-pill">{pill}</span>
              ))}
            </div>
          </div>

          <div className="about-visual fade-in fade-in-delay-1">
            {ABOUT_CARDS.map((card) => (
              <div key={card.title} className="about-card">
                <div className="icon">{card.icon}</div>
                <h4>{card.title}</h4>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
